import { render } from "./Inspection.vue?vue&type=template&id=da7142a8&scoped=true"
import script from "./Inspection.vue?vue&type=script&lang=ts"
export * from "./Inspection.vue?vue&type=script&lang=ts"

import "./Inspection.vue?vue&type=style&index=0&id=da7142a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-da7142a8"

export default script